import { ORDER_LOGISTICS } from '../../constants/orderLogistics';

export default function OrderLogisticsBadge({ logisticType }) {
    const meta = ORDER_LOGISTICS[logisticType];
    if (!meta) {
        return null;
    }
    const { Icon } = meta;
    return (
        <span
            title={meta.description}
            className={`inline-flex w-fit items-center gap-1 whitespace-nowrap px-1.5 py-0.5 text-[11px] font-semibold ${meta.tone}`}
        >
            <Icon size={13} aria-hidden="true" />
            {meta.label}
        </span>
    );
}
